import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import Services from './pages/Services';
import About from './pages/About';
import Contact from './pages/Contact';
import Team from './pages/Team';
import Portfolio from './pages/Portfolio';
import Careers from './pages/Careers';


import AIDevelopment from "./pages/Services/AIDevelopment";
import WebDesign from "./pages/Services/WebDesign";
import CloudDevOps from "./pages/Services/CloudDevOps";
import CustomSolutions from "./pages/Services/CustomSolutions";
import AppDevelopment from "./pages/Services/AppDevelopment";

import ScrollToTop from "./components/ScrollToTop"; // ✅ Add this line
import AIChatBot from "./components/AIChatBot";

function App() {
  useEffect(() => {
    AOS.init({ duration: 800, once: true });
  }, []);

  return (
    <Router>
      <ScrollToTop /> {/* ✅ Scroll reset happens here */}
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/services" element={<Services />} />
        <Route path="/about" element={<About />} />
        <Route path="/team" element={<Team />} />
        <Route path="/portfolio" element={<Portfolio />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/careers" element={<Careers />} />
        <Route path="/services/ai" element={<AIDevelopment />} />
        <Route path="/services/web" element={<WebDesign />} />
        <Route path="/services/cloud" element={<CloudDevOps />} />
        <Route path="/services/custom" element={<CustomSolutions />} />
        <Route path="/services/app" element={<AppDevelopment />} />
      </Routes>
      <Footer />
      <AIChatBot />
    </Router>
  );
}

export default App;
